import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { ControlIcons } from 'owa-control-icons';
import { moreLabel } from './TimeStreamToolboxOverflow.locstring.json';
import loc from 'owa-localize';
import useToolboxOverflowState from '../util/useToolboxOverflowState';
import TimeStreamToolboxButton from './TimeStreamToolboxButton';
import { Callout, DirectionalHint } from '@fluentui/react/lib/Callout';
import { FocusZone } from '@fluentui/react/lib/FocusZone';

export default observer(function TimeStreamToolboxOverflow({
    overflowItems,
}: {
    overflowItems: JSX.Element[];
}) {
    const timestreamToolboxExpandedWidth = 195;
    const { overflowTarget, onOverflowClick, onOverflowDismiss } = useToolboxOverflowState();
    const overflowStyle = { width: `${timestreamToolboxExpandedWidth}px` };

    return (
        <>
            <TimeStreamToolboxButton
                title={loc(moreLabel)}
                iconName={ControlIcons.More}
                onClick={onOverflowClick}
            />
            {!!overflowTarget && (
                <Callout
                    directionalHint={DirectionalHint.rightCenter}
                    target={overflowTarget}
                    onDismiss={onOverflowDismiss}
                    isBeakVisible={false}
                    setInitialFocus={true}
                    role="menu"
                    style={overflowStyle}>
                    <FocusZone>{overflowItems}</FocusZone>
                </Callout>
            )}
        </>
    );
});
